var map = {
	"./B2BWechat.jpg": 72171,
	"./footer.png": 6730,
	"./gongzonghao.jpg": 34514,
	"./home_aboutus.jpg": 21068,
	"./home_aboutus_title.png": 71663,
	"./home_bottom_bg.png": 79534,
	"./home_honor1.jpg": 23414,
	"./home_honor2.jpg": 73025,
	"./home_honor3.jpg": 94980,
	"./home_hotel_promotion_title.png": 19612,
	"./home_title_aboutus.png": 5047,
	"./home_youshi_bg.png": 80270,
	"./home_youshi_bg_fix.png": 86266,
	"./honour_2013.png": 13231,
	"./honour_2014.png": 70384,
	"./honour_2015.png": 67289,
	"./honour_2016.png": 2754,
	"./honour_2017.png": 40235,
	"./icon_no_xinyu.gif": 63053,
	"./icon_pay_xinyu.gif": 7034,
	"./list_hotel_position.svg": 12950,
	"./list_park_free_new.svg": 11284,
	"./list_sort.svg": 40810,
	"./list_sort2.svg": 92724,
	"./list_swim_new.svg": 59525,
	"./list_wifi_new.svg": 35318,
	"./logo.png": 82806,
	"./logo_bottom.png": 18914,
	"./pc_icon_phone-bg.png": 33247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;